<template>
  <div>
    <login-after-head ref="loginAfterHead"></login-after-head>

    <head-nav-bar></head-nav-bar>


    <div class="container mgB20">
      <div id="classify">
        <div class="type">
          <div class="key">
            品牌
            <span class="new-arrow-right"></span>
          </div>
          <div class="value">
            <div class="brand">
              <ul class="brand-box clearfix">
                <li>
                  <a href="javascript:void(0)" title="天正电气" class="selected SearchSelected">
                    <i class="icon-checkbox"></i>
                    <span class="search-tip wordBR ">天正电气</span>
                  </a>
                </li>
                <!--								<li>-->
                <!--									<a href="javascript:void(0)" title="其他">-->
                <!--										<i class="icon-checkbox "></i>-->
                <!--										<span class="search-tip wordBR ">其他</span>-->
                <!--									</a>-->
                <!--								</li>-->
              </ul>
            </div>
          </div>
          <div class="fun">
            <!--						<a href="javascript:void(0)" class="multi">多选</a>-->
            <a href="javascript:void(0)" @click="cleanCate">清除</a>
          </div>
        </div>
        <div class="type ">
          <div class="key ">一级 <span class="new-arrow-right "></span> </div>
          <div class="value">
            <div class="brand">
              <ul class="brand-box clearfix">
                <li v-for="(item,index) in levelOneMoreFlag?categoryList:categoryList.slice(0,7)">
                  <a href="javascript:void(0)" title="" :class="levelOne == index ?'SearchSelected':''" @click="changeLevel(1,index)">
                    <span class="search-tip wordBR">{{item.cateName}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="fun" v-if="categoryList.length>7">
            <a href="javascript:void(0)" class="more "  @click="changeLevelMore(1)">更多</a>
          </div>
        </div>
        <div class="type " v-if="categoryList[levelOne].children && categoryList[levelOne].children.length>0">
          <div class="key ">二级 <span class="new-arrow-right "></span> </div>
          <div class="value">
            <div class="brand">
              <ul class="brand-box clearfix">
                <li v-for="(item,index) in levelTwoMoreFlag?categoryList[levelOne].children:categoryList[levelOne].children.slice(0,7)">
                  <a href="javascript:void(0)" title="" :class="levelTwo == index ?'SearchSelected':''" @click="changeLevel(2,index)">
                    <span class="search-tip wordBR">{{item.cateName}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="fun" v-if="categoryList[levelOne].children.length>7">
            <a href="javascript:void(0)" class="more " @click="changeLevelMore(2)">更多</a>
          </div>
        </div>
        <div class="type " v-if="categoryList[levelOne].children[levelTwo].children && categoryList[levelOne].children[levelTwo].children.length >0">
          <div class="key ">三级 <span class="new-arrow-right "></span> </div>
          <div class="value">
            <div class="brand">
              <ul class="brand-box clearfix">
                <li v-for="(item,index) in levelThreeMoreFlag?categoryList[levelOne].children[levelTwo].children:categoryList[levelOne].children[levelTwo].children.slice(0,7)">
                  <a href="javascript:void(0)" title="" :class="levelThree == index ?'SearchSelected':''"  @click="changeLevel(3,index)">
                    <span class="search-tip wordBR  ">{{item.cateName}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="fun" v-if="categoryList[levelOne].children[levelTwo].children.length>7">
            <a href="javascript:void(0)" class="more " @click="changeLevelMore(3)">更多</a>
          </div>
        </div>
        <div class="type " v-if="displaySeriesList.length > 0">
          <div class="key ">系列 <span class="new-arrow-right "></span> </div>
          <div class="value">
            <div class="brand">
              <ul class="brand-box clearfix">
                <li v-for="(item,index) in levelFourMoreFlag ? displaySeriesList : displaySeriesList.slice(0, 7)">
                  <a href="javascript:void(0)" title="" :class="isSeriesSelected(item, index) ? 'SearchSelected' : ''"  @click="changeLevel(4,index,item.id)">
                    <span class="search-tip wordBR  ">{{item.cateName}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="fun" v-if="displaySeriesList.length > 7">
            <a href="javascript:void(0)" class="more " @click="changeLevelMore(4)">更多</a>
          </div>
        </div>
      </div>
      <div class="list-wrap">
        <div class="left-set-box">
          <div class="container-left leftSet">
            <div class="guess" style="position: relative">
              <span class="title">产品参数筛选</span>
              <span class="clear-icon" @click="cleanBox">清除选中</span>
            </div>
            <div class="related-box">
              <div class="good-item-bigBox">
                <ul class="attributes-ul">
                  <li class="attributes-item" v-for="(item,index) in productAttr" v-show="index<4 || lookAll" v-if="checkShowFun(index) && item.isShow">
                    <span class="attributes-one" :class="{active:item.fold}" @click="clickFold(item.fold,index)">{{item.attrName}}</span>
                    <div class="attributes-two" v-if="item.fold==true">
									      <span :class="arritem.checked==true?'attr-name attrActive':'attr-name'" title="1600AF"
                              v-for="(arritem,arrindex) in item.params" @click="clickBox(index,arrindex)"
                              v-if="checkItemShowFun(index,arrindex) && arritem.isShow">
                          <i class="icon-checkbox"></i>{{arritem.attrValue}}
                        </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="look-all" @click="lookAll=!lookAll" :class="{'look-all-active': !lookAll }">
                {{ lookAll ? '收起' : '展开'}}
              </div>
            </div>
          </div>
          <div class="none-list "   v-if="false">
            <span class="guess">产品参数筛选</span>
            <div class="none-list-tip">
              <span class="none-list-tip-one">!</span>
              <span>选择商品系列</span><br>
              <span>加载更多筛选条件</span>
            </div>
          </div>
        </div>
        <div class="search-list">
          <div class="quick-attr-card" v-if="showQuickAttr">
            <div class="quick-attr-head">
              <span class="quick-attr-series">当前系列 <b>{{ resolvedSeriesName }}</b></span>
              <span class="quick-attr-actions">
                <a href="javascript:void(0);" @click="scrollToSeries">切换系列</a>
                <a href="javascript:void(0);" v-if="hasNewSelection" @click="goSeriesDetail">新版选型</a>
                <a href="javascript:void(0);" @click="quickAttrCollapsed = !quickAttrCollapsed">{{ quickAttrCollapsed ? '展开参数' : '收起参数' }}</a>
              </span>
            </div>
            <div class="quick-attr-body" v-show="!quickAttrCollapsed">
              <div class="quick-attr-group" v-for="group in quickAttrGroups" :key="group.id">
                <div class="quick-attr-name">{{ group.attrName }}</div>
                <div class="quick-attr-chips">
                  <span class="quick-attr-chip"
                        :class="{active: param.checked}"
                        v-for="param in group.params"
                        :key="param.oldId"
                        @click="clickBox(group.groupIndex, param.paramIndex)">{{ param.attrValue }}</span>
                </div>
              </div>
              <div class="quick-attr-foot">
                <span class="quick-attr-tip">选择当前参数后，自动显示下一项</span>
                <a href="javascript:void(0);" class="quick-attr-reset" @click="resetQuickAttr">重置参数</a>
              </div>
            </div>
          </div>
          <div id="sctoolbar" style="margin-bottom: 20px;">
            <div class="sorting fc-bet">
              <div class="fc">
<!--                <a href="javascript:void(0);" class="order all-icon  active">综合</a>-->
                <a href="javascript:void(0);" :class="topClickShow == 1 ? 'order all-icon active' : 'order'" @click="changeTopClickShow(1)">综合</a>
<!--                <a href="javascript:void(0);" :class="topClickShow == 2 || topClickShow == 3 ? 'order all-icon active' : 'order'"  @click="changeTopClickShow(2)">销量<i :class="topClickShow == 3 ? 'up':''"></i></a>-->
                <a href="javascript:void(0);" :class="topClickShow == 4 || topClickShow == 5 ? 'order all-icon active' : 'order'"  @click="changeTopClickShow(3)"> 价格<i :class="topClickShow == 5 ? 'up':''"></i></a>
<!--                <a href="javascript:void(0);" class="order down-icon-two down-icon "  @click="topClickShow = 2"> 价格<i></i></a>-->
                <div class="price-range fc">
                  <input class="from from-price" type="text" placeholder="￥" maxlength="6" v-model="queryParams.minPrice" @blur="querySkuListsFun">
                  <span>−</span>
                  <input class="to  " type="text" placeholder="￥" maxlength="6" v-model="queryParams.maxPrice" @blur="querySkuListsFun">
                </div>
<!--                <div for="filterProduct" class="checkboxStyle-small ProductML active"> <i-->
<!--                    class="icon-checkbox"></i> <span></span> 有库存 </div>-->
                <!--								<div for="filterProduct" class="checkboxStyle-small ProductML stock-attr active"> <i-->
                <!--										class="icon-checkbox"></i> <span>常用1</span> -->
                <!--                </div>-->
                <div class="flip fc">
                  <span class="mgR15">共<b class="highlight">{{total}}</b>件商品</span>
                  <span class="mgR15 "><b class="highlight ">{{queryParams.page}}</b>/{{ totalPage }}</span>
                  <span :class="queryParams.page==1?'pag pag-one disable':'pag pag-one'" @click="unNextPage">
										<i></i>
									</span>
                  <span :class="queryParams.page==totalPage?'pag pag-two disable':'pag pag-two'" @click="nextPage">
										<i></i>
									</span>
                </div>
              </div>
              <div class="fc">
                <!--								<button type="button" class="btn-defult fcc">-->
                <!--									批量加入报价单-->
                <!--								</button>-->
                <button type="button" class="btn-defult fcc" @click="batchAddCartClick">
                  批量加入购物车
                </button>
              </div>
            </div>
          </div>
          <div class="table-list">
            <table class="pro-table" border="0" cellspacing="0" cellpadding="0">
              <thead>
              <tr>
                <th>物料</th>
                <th>含税面价</th>
                <th>折扣价</th>
                <th>数量</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in skuList">
                <td width="700" class="posR" align="left">
										<span class="clearfix">
											<div class="content-left">
												<router-link :to="{path:'/details',query:{unique:item.unique}}">
<!--                          <img class="img" src="../assets/pro-img1.jpg">-->
                          <img class="img" v-if="item.image" :src="item.image"/>
                          <img class="img" v-else src="../assets/noll.png"/>
                        </router-link>
											</div>
											<div class="content-right">
												<p class="name">
													<router-link :to="{path:'/details',query:{unique:item.unique}}">{{ item.skuName }}</router-link>
												</p>
												<p class="code">
                          <router-link :to="{path:'/details',query:{unique:item.unique}}">
                            产品编码 : {{ item.unique }}
                          </router-link>
												</p>
												<p class="num clearfix"> <a href="#" target="_blank"></a>
<!--                          <span class="dis w40 ">销量 : {{item.sales}}</span>-->
                          <span class="dis w40 ">箱装数 : {{item.packageQuantity}}</span>
                        </p>
											</div>
										</span>
                </td>
                <td width="160" v-if="item.unpriced ==1" >面议</td>
                <td width="160"  v-else>￥{{ item.otPrice ? item.otPrice.toFixed(2) : 0 }}</td>
                <td width="160" v-if="item.unpriced ==1">面议</td>
                <td width="160"  v-else>￥{{ item.price ? item.price : 0 }}</td>
                <td width="150">
                  <a class="address-lh " style="cursor:pointer;" @click="downNumbers(index)">-</a>
                  <input type="text" class=" " value="0" v-model="item.cartNum"
                         oninput="if(value)value=value.replace(/[^0-9]/g,'');if(value>999999)value=999999;if(value.length>6)value=value.slice(0,6);if(value<0)value=0"
                  >
                  <a class="address-lh " style="cursor:pointer;" @click="upNumbers(index)">+</a>
                </td>
                <td width="120">
                  <!--                    <span class="f12 cursorPointer ">加入收藏</span> -->
                  <span v-if="item.unpriced ==1" class="f12 cursorPointer addCartPer" >价格面议</span>
                  <span v-else class="f12 cursorPointer addCartPer" @click="addCartClick(index)">加入购物车</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <div class="page-row fc-bet">
            <div></div>
            <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.page"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="queryParams.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import {
  addCart,
  addCartBatch, getQueryCateByProductId,
  queryAttrList,
  queryCategoryList,
  queryHomeProduct,
  queryHomeProductPost,
  queryProducts,
  querySkuLists
} from "@/api/home";
import {cartCount} from "@/api/cart";
import {getSeriesOptions} from "@/api/descGen";
import {mapMutations} from 'vuex'
import state from "@/store/state";

let seriesOptionsPromise = null;

export default {

  data() {
    return {
		  oldIdList: [],
      topClickShow : 0,
      total : 0,
      totalPage : 1,
      queryParams:{
        minPrice : null,
        maxPrice : null,
        orderByPrice : null,
        orderBySales : null,
        page : 1,
        limit : 10,
        productId : null,
        params:[]
      },
      // 展开折叠
      skuList:[],
      fold1:true,
      fold2:true,
      fold3:true,
      fold4:true,
      fold5:true,

      productAttr:[],
      lookAll:false,
      showMore:false,
      categoryList:[],
      levelOne:0,
      levelTwo:0,
      levelThree:0,
      levelFour:0,
      levelOneMoreFlag:false,
      levelTwoMoreFlag:false,
      levelThreeMoreFlag:false,
      levelFourMoreFlag:false,

      cate1Id:null,
      cate2Id:null,
      cate3Id:null,

      skuName:null,
      productId:null,
      activeCategoryFourId: null,
      activeSeriesTreeId: null,
      quickAttrCollapsed: false,
      newSelectionMap: null,
    }
  },
  computed: {
    displaySeriesList() {
      return this.dedupeSeriesList(this.getSeriesListAtCurrentPath())
    },
    resolvedSeriesName() {
      const list = this.displaySeriesList
      if (this.activeSeriesTreeId != null) {
        const found = list.find(item => Number(item.id) === Number(this.activeSeriesTreeId))
        if (found && found.cateName) return found.cateName
      }
      const l1 = this.categoryList[this.levelOne]
      const l2 = l1 && l1.children && l1.children[this.levelTwo]
      const l3 = l2 && l2.children && l2.children[this.levelThree]
      const node = l3 && l3.children && l3.children[this.levelFour]
      return (node && node.cateName) || ''
    },
    showQuickAttr() {
      return this.productAttr.length > 0 && !!this.resolvedSeriesName
    },
    currentSeriesProductId() {
      const group = this.productAttr && this.productAttr[0]
      const productId = group && group.productId
      return productId != null ? Number(productId) : null
    },
    hasNewSelection() {
      const productId = this.currentSeriesProductId
      if (productId == null || !this.newSelectionMap) return false
      return Number(this.newSelectionMap[productId]) === 1
    },
    quickAttrGroups() {
      const groups = []
      if (!this.productAttr || !this.productAttr.length) return groups
      let revealUntil = -1
      this.productAttr.forEach((group, index) => {
        const hasChecked = (group.params || []).some(param => param.checked)
        if (hasChecked) revealUntil = Math.max(revealUntil, index)
      })
      const end = Math.min(this.productAttr.length - 1, revealUntil + 1)
      for (let i = 0; i <= end; i++) {
        const group = this.productAttr[i]
        if (!group || group.isShow === false) continue
        const params = (group.params || [])
          .map((param, paramIndex) => Object.assign({}, param, { paramIndex }))
          .filter(param => param.isShow !== false)
        if (!params.length) continue
        groups.push({
          id: group.id || ('quick-group-' + i),
          attrName: group.attrName,
          groupIndex: i,
          params
        })
      }
      return groups
    }
  },
  mounted() {
    this.loadSeriesOptions()
    //缓存处理
    this.initPage()

  },
  watch: {
    "$route.query.cate1Id": function(val) {
      console.log('cate1Id监听:',val)
      this.$router.go(0);
      // this.initPage()
    },
    "$route.query.cate2Id": function(val) {
      console.log('cate2Id监听:',val)
      this.$router.go(0);
      // this.initPage()
    },
    "$route.query.cate3Id": function(val) {
      console.log('cate3Id监听:',val)
      this.$router.go(0);
      // this.initPage()
    },
    "$route.query.searchValue": function(val) {
      console.log('searchValue监听:',val)
      //刷新页面
      this.$router.go(0);
      this.initPage()
    },
    "$route.query.productId": function(val) {
      console.log('productId监听:',val)
      this.initPage()
    },
    "oldIdList": function(val) {
      console.log('旧id列表',this.oldIdList)
    },
  },
  methods: {
    parseCategoryCache(raw) {
      if (!raw) return null
      try {
        const parsed = JSON.parse(raw)
        if (Array.isArray(parsed)) return parsed
        if (parsed && Array.isArray(parsed.categorys)) return parsed.categorys
      } catch (e) { /* ignore */ }
      return null
    },
    ensureCategoryListLoaded() {
      const cached = this.parseCategoryCache(sessionStorage.getItem('categorys'))
      if (cached && cached.length) {
        this.categoryList = cached
        return Promise.resolve()
      }
      return queryCategoryList().then(res => {
        this.categoryList = res.categorys || []
        sessionStorage.setItem('categorys', JSON.stringify(this.categoryList))
      })
    },
    initPage(){
      this.cate1Id = this.$route.query.cate1Id
      this.cate2Id = this.$route.query.cate2Id
      this.cate3Id = this.$route.query.cate3Id
      this.skuName = this.$route.query.searchValue
      this.productId = this.$route.query.productId
      console.log('页面初始化参数',this.cate1Id, this.cate2Id, this.cate3Id , this.skuName )
      this.ensureCategoryListLoaded().then(() => {
        this.defaultCates()
        this.querySkuNameHanlder()
        this.bootstrapListFromCateRoute()
      })
    },
    //查询列表
    querySkuListsFun(){
      const noSkuName = this.queryParams.skuName == null || this.queryParams.skuName === ''
      const noProductId = this.queryParams.productId == null || this.queryParams.productId === ''
      if (noSkuName && noProductId) {
        this.cleanAllParams()
        this.$message.warning('产品不存在')
        return
      }
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      //console.log("list userInfo.uid",userInfo);
      if (userInfo && userInfo.name){
        this.queryParams.userName = userInfo.name;
      }  
      console.log('查询SKU列表',this.queryParams)
      querySkuLists(this.queryParams).then(res => {
        console.log('SKU列表查询结果',res)
        this.skuList = res.data.skuList
        this.totalPage = res.totalPage
        this.total = res.total
        for (let re of  this.skuList) {
          re.cartNum=0
        }
      })
    },
   //下一页 上一页
	 nextPage() {
      if (this.queryParams.page==this.totalPage){
        return
      }
      this.queryParams.page=this.queryParams.page+1
     this.querySkuListsFun()
   },
	 unNextPage() {
      if (this.queryParams.page>1) {
        this.queryParams.page = this.queryParams.page - 1
        this.querySkuListsFun()
      }
   },
	 handleSizeChange(val) {
     console.log(`每页 ${val} 条`);
     this.queryParams.limit = val
     this.querySkuListsFun()
   },
   handleCurrentChange(val) {
     console.log(`当前页: ${val}`);
     this.queryParams.page = val
     this.querySkuListsFun()
   },
    ...mapMutations({
      setCartNum: 'SET_CARTNUM' // 修改vuex购物车数量
    }),
    // 获取购物车商品数量
    async getCartNum () {
      const res = await cartCount()
      if (res.status === 200) {
        this.setCartNum(res.data.count)
      } else {
        this.$message.warning(res.msg)
      }
    },
    addCartClick(index){
      let userInfo = this.$state.userInfo
      console.log("userInfo",userInfo)
      if(userInfo=='{}'){
        this.$router.push({path:'/login'})
        return;
      }
      console.log()
      if (this.skuList[index].cartNum>0){
        let addCartPamars={
          uniqueId:this.skuList[index].unique,
          cartNum:this.skuList[index].cartNum,
          productId:this.skuList[index].productId,
        }
        console.log('加入购物车',addCartPamars)
        addCart(addCartPamars).then(res=>{
          console.log('添加购物车成功结果',res)
          // this.skuList[index].cartNum=0
          this.$message.success('添加成功')
          this.getCartNum()
          this.$forceUpdate()
          const _this = this.$refs.loginAfterHead;
          _this.getCartList()
        })
      }
    },
    //批量加入购物车 uniqueId  cartNum   productId
    batchAddCartClick(){
      let userInfo = this.$state.userInfo
      console.log("userInfo",userInfo)
      if(userInfo=='{}'){
        this.$router.push({path:'/login'})
        return;
      }
      let allCartNum = 0
      let addCartListParams = this.skuList.filter(e=>e.cartNum>0)
      let addCartLists=[]
      for (const argument of addCartListParams) {
        let addCartListItem={
          uniqueId:argument.unique,
          cartNum:argument.cartNum,
          productId:argument.productId,
        }
        addCartLists.push(addCartListItem)
      }
      if (addCartLists && addCartLists.length>0){
        addCartBatch(addCartLists).then(res=>{
          // for (let argument of this.skuList) {
          //   argument.cartNum=0
          // }
          this.$message.success('添加成功')
          this.getCartNum()
          this.$forceUpdate()
          const _this = this.$refs.loginAfterHead;
          _this.getCartList()
        })
      }
    },
    //动态参数表单控制
    checkShowFun(index){
      let productAttrItem = this.productAttr[index]

      //判断是否显示的依据是 参数是否有 belongId
      let showCountFlag = true
      for (const productAttrItemElement of productAttrItem.params) {
        if (productAttrItemElement.belongParamId){
          showCountFlag = false
          let belongIds = productAttrItemElement.belongParamId.split(',')
          let belongIdInts =[]
          if (belongIds && belongIds.length>0){
            belongIds.forEach(item=>{
              belongIdInts.push(Number.parseInt(item))
            })
          }
          let samePart = this.oldIdList.filter(item=>belongIdInts.includes(item));//交集
          if (samePart && samePart.length>0){
            showCountFlag =  true
            break
          }
        }
      }
      if (showCountFlag == false){
        return false
      }
      return true
    },

    //动态参数表单控制
    checkItemShowFun(index,arrIndex){
      let productAttrItem = this.productAttr[index].params[arrIndex]
      if (productAttrItem.belongParamId) {
        let belongIds = productAttrItem.belongParamId.split(',')
        let belongIdInts =[]
        if (belongIds && belongIds.length>0){
          belongIds.forEach(item=>{
            belongIdInts.push(Number.parseInt(item))
          })
        }
        let samePart = this.oldIdList.filter(item=>belongIdInts.includes(item));//交集
        if (samePart && samePart.length>0){
          return true
        }else{
          return false
        }
      }
      // for (const productAttrItemElement of productAttrItem.params) {
      //   if (productAttrItemElement.belongParamId){
      //     console.log(productAttrItemElement.attrName+'中有上级关联，暂不显示'+productAttrItemElement.oldId)
      //     return false
      //   }
      // }
      return true
    },
    upNumbers(index){
      console.log(this.skuList[index].cartNum)
      this.skuList[index].cartNum = this.skuList[index].cartNum+1
      this.$forceUpdate()
    },
    downNumbers(index){
      console.log(this.skuList[index].cartNum)
      if (this.skuList[index].cartNum>0){
        this.skuList[index].cartNum = this.skuList[index].cartNum-1
        this.$forceUpdate()
      }
    },
    //清除选中 初始化参数
    cleanBox(){
      if (this.productAttr && this.productAttr.length>0 ){
        this.productAttr.forEach(item=> {
          if (item.params){
            item.params.forEach(paramItem=>{
              paramItem.checked=false
            })
          }
        })
        this.queryParams.params = []
        this.oldIdList = []
        this.queryParams.productId=this.productAttr[0].productId
        this.querySkuListsFun()    
      }
    },
    scrollToSeries() {
      this.levelFourMoreFlag = true
      this.$nextTick(() => {
        const el = document.getElementById('classify')
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },
    goSeriesDetail() {
      const productId = this.currentSeriesProductId
      if (!productId) return
      this.$router.push({
        path: '/selection',
        query: { categoryId: productId, keyword: this.resolvedSeriesName }
      })
    },
    loadSeriesOptions() {
      if (!seriesOptionsPromise) {
        seriesOptionsPromise = getSeriesOptions().then(res => {
          const list = (res && res.data) ? res.data : []
          const map = {}
          list.forEach(item => {
            if (item && item.categoryId != null) {
              map[Number(item.categoryId)] = Number(item.status)
            }
          })
          return map
        }).catch(() => {
          seriesOptionsPromise = null
          return {}
        })
      }
      seriesOptionsPromise.then(map => {
        this.newSelectionMap = map
      })
    },
    resetQuickAttr() {
      this.cleanBox()
      this.queryHomeProductWithAttrs()
    },
    clickBox(index,arrindex){
      if (this.productAttr[index].params[arrindex].checked){
        //至少需要一个参数校验
        let countChange = 0
        for (const indexKey of this.productAttr) {
          if (indexKey.params){
            for (const indexKey2 of indexKey.params) {
              if (indexKey2.checked){
                countChange = countChange+1
              }
            }
          }
        }
        //如果当前只有一个选项 还要取消 则忽略
        if (countChange>1){
          this.productAttr[index].params[arrindex].checked=false
          this.oldIdList = this.oldIdList.filter(item=>item!=this.productAttr[index].params[arrindex].oldId)
        }
      }else{
        for (const indexKey of this.productAttr[index].params) {
          if (indexKey.checked){
            indexKey.checked=false
          }
          this.oldIdList = this.oldIdList.filter(item=>item!=indexKey.oldId)
        }
        this.productAttr[index].params[arrindex].checked = true
        this.oldIdList.push(this.productAttr[index].params[arrindex].oldId)
      }
      this.handelChooseParams()
      //this.$forceUpdate()
      //刷新左侧属性（最小改动：任意参数切换都刷新）
      this.queryHomeProductWithAttrs();
      //拼接查询参数
      // let queryJson = ''
      // this.productAttr.forEach(e=>{
      //   if (e.attrValue){
      //     e.forEach(y=>{
      //       if (y==''){
      //         queryJson+=y
      //       }else{
      //         queryJson+=','
      //         queryJson+=y
      //       }
      //     })
      //   }
      // })
      // console.log('查询json为：',queryJson)
    },

    handelChooseParams(){
      // 用户手动点选规格后，按规格筛选，不再叠加搜索关键词
      if (this.skuName) {
        this.queryParams.skuName = null
      }
      let chooseParams=[]
      let productIdLet = null
      for (const indexKey of this.productAttr) {
        if (indexKey.params){
          for (const indexKey2 of indexKey.params) {
            if (indexKey2.checked){
              chooseParams.push(indexKey2)
            }
          }
        }
        productIdLet = indexKey.productId
        // let chooseParamsItem = {
        //   attrName:indexKey.attrName,
        //   attrValues:indexKey.attrValues,
        //   belongSpecId:indexKey.belongSpecId,
        //   fold:indexKey.fold,
        //   id:indexKey.id,
        //   oldId:indexKey.oldId,
        //   productId:indexKey.productId,
        //   sort:indexKey.sort,
        //   params : chooseParamsItemParams
        // }
        // chooseParams.push(chooseParamsItem)
        // if (chooseParamsItem.params && chooseParamsItem.params.length>0){
        //   chooseParams.push(chooseParamsItem)
        // }
      }
      this.queryParams.productId = productIdLet
      this.queryParams.params = chooseParams      
      //调用查询接口
      this.querySkuListsFun();      
    },

    changeLevel(level,index,id){
      console.log(level,index)
      if (level == 1){
        this.levelOne = index
        this.levelTwo = 0
        this.levelThree = 0
        this.levelFour = -1
      }else if (level == 2){
        this.levelTwo = index
        this.levelThree = 0
        this.levelFour = -1
      }else if (level == 3){
        this.levelThree = index
        this.levelFour = -1
      }else if (level == 4){
        this.levelFour = index
      }
      this.$forceUpdate()
      if (id) {
        this.activeSeriesTreeId = id
        //去除搜索值
        this.queryParams.skuName=null
        this.queryHomeProductFun(id)
        // this.queryProductFun(id)
      }
    },
    changeLevelMore(level){
      console.log(level)
      if (level == 1){
        if (this.levelOneMoreFlag){
          this.levelOneMoreFlag=false
        }else{
          this.levelOneMoreFlag=true
        }
      }else if (level == 2){
        if (this.levelTwoMoreFlag){
          this.levelTwoMoreFlag=false
        }else{
          this.levelTwoMoreFlag=true
        }
      }else if (level == 3){
        if (this.levelThreeMoreFlag){
          this.levelThreeMoreFlag=false
        }else{
          this.levelThreeMoreFlag=true
        }
      }else if (level == 4){
        if (this.levelFourMoreFlag){
          this.levelFourMoreFlag=false
        }else{
          this.levelFourMoreFlag=true
        }
      }
    },

    queryHomeProductFun(id) {
      let queryProduct={
        categoryId:id
      }
      queryHomeProduct(queryProduct).then(res=>{
        console.log('规格查询结果',res.length)
        if(res.length ==0 || res.status=='5101'){
          console.log('规格不存在')
          this.cleanAllParams()
          this.queryProductFun(id);
        }else{
          this.productAttr =  res
          this.productAttr.forEach(e=>{
            e.fold=true
          })
          this.cleanBox()

        }

        // if (this.productAttr && this.productAttr.length>0 ){
        //   this.productAttr[0].params[0].check = true
        //   this.queryParams.params.push(this.productAttr[0].params[0])
        //   this.oldIdList = []
        //   this.oldIdList.push(this.productAttr[0].params[0].oldId)
        //   this.queryParams.productId=this.productAttr[0].productId
        //   this.querySkuListsFun()
        // }
      })
    },
    //带类目属性参数刷新 属性列表
    queryHomeProductWithAttrs() {      
      console.log('queryHomeProductWithAttrs',this.queryParams)
      queryHomeProductPost(this.queryParams).then(res=>{
        console.log('规格查询结果',res.data )
        if(res.status != 200){
          console.log('规格不存在')
          this.cleanAllParams()
        }else{
          this.productAttr =  res.data
          this.productAttr.forEach(e=>{
            e.fold=true
          })
          //this.cleanBox()

        }

      })
    },
    queryProductFun(id) {
      let queryProduct={
        categoryId:id
      }
      queryProducts(queryProduct).then(res=>{
        this.queryParams.params = []
        this.queryParams.productId = res.id
        this.querySkuListsFun()
      })
    },
    queryCategoryListFun() {
      this.ensureCategoryListLoaded().then(() => {
        this.defaultCates()
        this.querySkuNameHanlder()
        this.bootstrapListFromCateRoute()
      })
    },

    applySkuListRes(res) {
      const list = (res.data && res.data.skuList) ? res.data.skuList : []
      this.skuList = list
      this.totalPage = res.totalPage || 1
      this.total = res.total || 0
      for (const item of this.skuList) {
        item.cartNum = 0
      }
    },
    querySkuNameHanlder(){
      this.queryParams.skuName = null
      this.queryParams.productId = null
      if (this.productId){
        this.queryParams.productId = this.productId
      }
      if (this.skuName){
        this.queryParams.productId = null
        this.queryParams.skuName = this.skuName
        this.queryParams.params = []
      }
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      //console.log("list userInfo.uid",userInfo);
      if (userInfo && userInfo.name){
        this.queryParams.userName = userInfo.name;
      }  
      if (this.skuName || this.productId) {
        querySkuLists(this.queryParams).then(res => {
          console.log('反向查询分类-SKU列表查询结果', res)
          this.applySkuListRes(res)
          const productId = this.resolveProductIdForCateLookup(res)
          if (productId) {
            this.doFindCateClassHanlder(productId, !!this.skuName || !!this.productId)
          }
        })
      }
    },
    // 从 getSkuList 结果取系列 productId，再经 query-cate/products 反推各级类目
    resolveProductIdForCateLookup(res) {
      if (this.productId) {
        return this.productId
      }
      const data = (res && res.data) ? res.data : {}
      const productList = data.productList || []
      const skuList = data.skuList || []
      if (productList.length && productList[0].id) {
        return productList[0].id
      }
      if (skuList.length && skuList[0].productId) {
        return skuList[0].productId
      }
      return null
    },
    // query-cate 返回的 id 可能是 DMS 类目 id，与树节点 id 不一致，需兼容 dmsCat / dmsTgCategoryId
    isCateNodeMatchId(item, cateId) {
      if (!item || cateId == null) return false
      const nid = Number(cateId)
      const sid = String(cateId)
      if (Number(item.id) === nid) return true
      if (item.categoryId != null && Number(item.categoryId) === nid) return true
      if (item.dmsTgCategoryId != null && Number(item.dmsTgCategoryId) === nid) return true
      if (item.dmsCat) {
        const cats = String(item.dmsCat).split(',').map(s => s.trim())
        if (cats.indexOf(sid) > -1) return true
      }
      return false
    },
    findChildIndexByCateId(children, cateId) {
      if (!children || cateId == null) return -1
      return children.findIndex(item => this.isCateNodeMatchId(item, cateId))
    },
    getSeriesListAtCurrentPath() {
      const l1 = this.categoryList[this.levelOne]
      if (!l1 || !l1.children) return []
      const l2 = l1.children[this.levelTwo]
      if (!l2 || !l2.children) return []
      const l3 = l2.children[this.levelThree]
      if (!l3 || !l3.children) return []
      return l3.children
    },
    getSeriesBrowse(item) {
      if (!item) return 0
      if (item.browse != null && item.browse !== '') return Number(item.browse) || 0
      if (item.product && item.product.browse != null) return Number(item.product.browse) || 0
      return 0
    },
    getSeriesDedupeKey(item) {
      if (!item) return ''
      if (item.dmsTgCategoryId != null && item.dmsTgCategoryId !== '') {
        return 'tg:' + item.dmsTgCategoryId
      }
      if (item.dmsCode) {
        return 'code:' + item.dmsCode
      }
      return 'id:' + item.id
    },
    isSameSeriesNode(a, b) {
      if (!a || !b) return false
      return this.getSeriesDedupeKey(a) === this.getSeriesDedupeKey(b)
    },
    dedupeSeriesList(list) {
      if (!list || !list.length) return []
      const seen = new Map()
      const result = []
      for (const item of list) {
        const key = this.getSeriesDedupeKey(item)
        if (seen.has(key)) {
          const prev = seen.get(key)
          if (this.getSeriesBrowse(item) > this.getSeriesBrowse(prev)) {
            result[result.indexOf(prev)] = item
            seen.set(key, item)
          }
          continue
        }
        seen.set(key, item)
        result.push(item)
      }
      const hasBrowse = result.some(item => this.getSeriesBrowse(item) > 0)
      if (!hasBrowse) return result
      return result.slice().sort((a, b) => {
        const browseDiff = this.getSeriesBrowse(b) - this.getSeriesBrowse(a)
        if (browseDiff !== 0) return browseDiff
        const nameA = (a && a.cateName) || ''
        const nameB = (b && b.cateName) || ''
        return nameA.localeCompare(nameB, 'zh')
      })
    },
    findCatePathByRouteIds(cate1Id, cate2Id, cate3Id) {
      for (let i = 0; i < this.categoryList.length; i++) {
        const children1 = this.categoryList[i].children || []
        for (let j = 0; j < children1.length; j++) {
          if (cate1Id != null && !this.isCateNodeMatchId(this.categoryList[i], cate1Id)) continue
          if (cate2Id != null && !this.isCateNodeMatchId(children1[j], cate2Id)) continue
          const children2 = children1[j].children || []
          for (let k = 0; k < children2.length; k++) {
            if (cate3Id != null && !this.isCateNodeMatchId(children2[k], cate3Id)) continue
            return { levelOne: i, levelTwo: j, levelThree: k }
          }
        }
      }
      return null
    },
    // 从详情面包屑等带 cate1/2/3Id 进入时，定位类目后加载默认系列商品
    bootstrapListFromCateRoute() {
      if (this.skuName || this.$route.query.searchValue) return
      if (this.$route.query.productId) return
      if (!this.cate1Id && !this.cate2Id && !this.cate3Id) return
      const seriesList = this.dedupeSeriesList(this.getSeriesListAtCurrentPath())
      if (seriesList.length) {
        if (this.levelFour < 0) {
          this.levelFour = 0
        }
        const seriesNode = seriesList[this.levelFour] || seriesList[0]
        if (seriesNode && seriesNode.id) {
          this.activeSeriesTreeId = seriesNode.id
          this.activeCategoryFourId = seriesNode.dmsTgCategoryId || seriesNode.id
          this.queryParams.skuName = null
          this.queryHomeProductFun(seriesNode.id)
        }
      }
    },
    parseQueryCateRes(raw) {
      if (!raw) return null
      if (raw.categoryOneId != null || raw.categoryFourId != null) return raw
      if (raw.data) return raw.data
      return raw
    },
    isSeriesSelected(item, index) {
      if (this.levelFour === index) return true
      if (this.activeSeriesTreeId != null && item) {
        return Number(item.id) === Number(this.activeSeriesTreeId)
      }
      return false
    },
    expandCateMoreIfNeeded(level, index) {
      if (index >= 7) {
        if (level === 1) this.levelOneMoreFlag = true
        else if (level === 2) this.levelTwoMoreFlag = true
        else if (level === 3) this.levelThreeMoreFlag = true
        else if (level === 4) this.levelFourMoreFlag = true
      }
    },
    // 在产品树中按系列（叶子）id 定位，再沿父子层级反推 1～3 级下标（1～3 级与 query-cate 的 DMS id 不是同一套）
    findSeriesPathInTree(seriesCateId) {
      if (seriesCateId == null || !this.categoryList || !this.categoryList.length) return null
      for (let i = 0; i < this.categoryList.length; i++) {
        const children1 = this.categoryList[i].children || []
        for (let j = 0; j < children1.length; j++) {
          const children2 = children1[j].children || []
          for (let k = 0; k < children2.length; k++) {
            const children3 = children2[k].children || []
            let targetNode = null
            for (let m = 0; m < children3.length; m++) {
              if (Number(children3[m].id) === Number(seriesCateId)) {
                targetNode = children3[m]
                break
              }
            }
            if (!targetNode) {
              for (let m = 0; m < children3.length; m++) {
                if (this.isCateNodeMatchId(children3[m], seriesCateId)) {
                  targetNode = children3[m]
                  break
                }
              }
            }
            if (!targetNode) continue
            const deduped = this.dedupeSeriesList(children3)
            const levelFour = deduped.findIndex(d => this.isSameSeriesNode(d, targetNode))
            return {
              levelOne: i,
              levelTwo: j,
              levelThree: k,
              levelFour: levelFour >= 0 ? levelFour : 0,
              categoryFourId: seriesCateId,
              seriesTreeId: targetNode.id
            }
          }
        }
      }
      return null
    },
    applyCateNavPath(path) {
      if (!path) return
      this.levelOne = path.levelOne
      this.levelTwo = path.levelTwo
      this.levelThree = path.levelThree
      this.levelFour = path.levelFour
      this.activeCategoryFourId = path.categoryFourId
      this.activeSeriesTreeId = path.seriesTreeId || null
      this.expandCateMoreIfNeeded(1, path.levelOne)
      this.expandCateMoreIfNeeded(2, path.levelTwo)
      this.expandCateMoreIfNeeded(3, path.levelThree)
      this.expandCateMoreIfNeeded(4, path.levelFour)
      this.$forceUpdate()
    },
    // 仅用 categoryFourId 在产品树中定位；一～三级由树结构反推，不用 query-cate 的 categoryOne～ThreeId
    syncCategoryNavByCateIds(cateRes) {
      if (!cateRes || !this.categoryList || !this.categoryList.length) return false
      const seriesId = cateRes.categoryFourId
      if (seriesId == null) return false
      const path = this.findSeriesPathInTree(seriesId)
      if (path) {
        this.applyCateNavPath(path)
        return true
      }
      this.activeCategoryFourId = seriesId
      this.levelFour = -1
      this.$forceUpdate()
      return false
    },
    loadProductAttrByCategoryId(categoryId, productId, fromSearch) {
      if (!categoryId) return
      queryHomeProduct({ categoryId }).then(arrRes => {
        console.log('反向查询分类 -规格查询结果', arrRes)
        if (arrRes.length === 0) {
          console.log('规格不存在')
          if (!fromSearch && (!this.skuList || this.skuList.length === 0)) {
            this.cleanAllParams()
            this.queryProductFun(productId)
          }
          return
        } else {
          this.productAttr = arrRes
          this.productAttr.forEach(e => { e.fold = true })
          if (fromSearch) {
            this.productAttr.forEach(item => {
              if (item.params) {
                item.params.forEach(p => { p.checked = false })
              }
            })
            this.queryParams.params = []
            this.oldIdList = []
          } else {
            this.cleanBox()
          }
        }
      })
    },
    // 根据系列 productId 反查一二三四级类目 id，再映射到本地类目树高亮
    doFindCateClassHanlder(productId, fromSearch, cateRetry){
      if (!productId) return
      getQueryCateByProductId({ productId }).then(raw => {
        const cateRes = this.parseQueryCateRes(raw)
        console.log('反向查询分类 productId=', productId, cateRes)
        const finish = () => {
          const synced = this.syncCategoryNavByCateIds(cateRes)
          if (cateRes && cateRes.categoryFourId) {
            this.loadProductAttrByCategoryId(cateRes.categoryFourId, productId, fromSearch)
          }
          return synced
        }
        this.ensureCategoryListLoaded().then(() => {
          if (!finish() && !cateRetry) {
            queryCategoryList().then(res => {
              this.categoryList = res.categorys || []
              sessionStorage.setItem('categorys', JSON.stringify(this.categoryList))
              finish()
            })
          }
        })
      })
    },
    cleanAllParams(){
      this.skuList = []
      this.productAttr = []
      this.total = 0
      this.totalPage = 0
      this.queryParams.page = 1
      this.queryParams.limit = 10
    },
    defaultCates(){
      console.log('进入defaultCates')
      this.cleanAllParams()
      if (!this.cate1Id && !this.cate2Id && !this.cate3Id&& !this.productId && !this.productId && !this.skuName){
        console.log('进入0case')
        // levelOne
        this.levelOne = 0
        this.levelTwo = 0
        this.levelThree = 0
        this.levelFour = -1
        this.levelQueryProductId()
      }else if (this.cate1Id && !this.cate2Id && !this.cate3Id && !this.productId && !this.skuName){
        console.log('进入1case')
        // levelOne
        const index = this.findChildIndexByCateId(this.categoryList, this.cate1Id)
        if (index>-1){
          this.levelOne = index
        }
        this.levelTwo = 0
        this.levelThree = 0
        this.levelFour = -1
        this.levelQueryProductId()
      }else if (this.cate1Id && this.cate2Id && !this.cate3Id && !this.productId && !this.skuName){
        console.log('进入2case',this.cate1Id,this.cate2Id)
        // levelOne
        const index = this.findChildIndexByCateId(this.categoryList, this.cate1Id)
        if (index>-1){
          this.levelOne = index
          if (this.cate2Id) {
            console.log(this.categoryList[index].children)
            const index2 = this.findChildIndexByCateId(this.categoryList[index].children, this.cate2Id)
            if (index2>-1){
              this.levelTwo = index2
            }
          }
        }
        this.levelThree = 0
        this.levelFour = -1
        this.levelQueryProductId()
      }else if (!this.cate1Id && this.cate2Id && this.cate3Id && !this.productId && !this.skuName){
        console.log('进入3case')
        let path = this.findCatePathByRouteIds(null, this.cate2Id, this.cate3Id)
        if (!path && this.cate3Id) {
          path = this.findCatePathByRouteIds(null, null, this.cate3Id)
        }
        if (path) {
          this.levelOne = path.levelOne
          this.levelTwo = path.levelTwo
          this.levelThree = path.levelThree
          this.expandCateMoreIfNeeded(1, path.levelOne)
          this.expandCateMoreIfNeeded(2, path.levelTwo)
          this.expandCateMoreIfNeeded(3, path.levelThree)
        }
        this.levelFour = -1
        this.levelQueryProductId()
      } else if (this.skuName && !this.cate1Id && !this.cate2Id && !this.cate3Id && !this.productId) {
        this.levelFour = -1
      }
    },
    levelQueryProductId(){
      console.log('进入levelQueryProductId',this.levelOne,this.levelTwo,this.levelThree,this.levelFour)
      if (this.categoryList && this.categoryList[this.levelOne]){
        if (this.categoryList[this.levelOne].children && this.categoryList[this.levelOne].children[this.levelTwo]){
          if (this.categoryList[this.levelOne].children[this.levelTwo].children
              && this.categoryList[this.levelOne].children[this.levelTwo].children[this.levelThree]){
            if (this.categoryList[this.levelOne].children[this.levelTwo].children[this.levelThree].children
                && this.categoryList[this.levelOne].children[this.levelTwo].children[this.levelThree].children[this.levelFour]
                && this.categoryList[this.levelOne].children[this.levelTwo].children[this.levelThree].children[this.levelFour].id){
              this.productId = this.categoryList[this.levelOne].children[this.levelTwo].children[this.levelThree].children[this.levelFour].id
            }
          }
        }
      }
      console.log('进入levelQueryProductId',this.levelOne,this.levelTwo,this.levelThree,this.levelFour,this.productId)
    },
    cleanCate(){
      this.levelOne=0
      this.levelTwo=0
      this.levelThree=0
      this.levelFour=0
      this.activeCategoryFourId = null
      this.activeSeriesTreeId = null
    },
    clickFold(fold,index){
      console.log(fold,index,this.productAttr[index].fold)
      if (fold){
        this.productAttr[index].fold=false
      }else{
        this.productAttr[index].fold=true
      }
      this.$forceUpdate()
    },
    changeTopClickShow(index){
     if (index==1){
        this.topClickShow = 1
       this.queryParams.orderByPrice=null
       this.queryParams.orderBySales=null
     }else if (index==2){
       if ( this.topClickShow == 2){
         this.topClickShow = 3
         this.queryParams.orderBySales='desc'
       }else{
         this.queryParams.orderBySales='asc'
         this.topClickShow = 2
       }
       this.queryParams.orderByPrice=null
     }else if (index==3){
       if ( this.topClickShow == 4){
         this.queryParams.orderByPrice='desc'
         this.topClickShow = 5
       }else{
         this.queryParams.orderByPrice='asc'
         this.topClickShow = 4
       }
       this.queryParams.orderBySales=null
     }
     this.querySkuListsFun()
    }
  },


}
</script>

<style scoped lang="less">
.quick-attr-card {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.quick-attr-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.quick-attr-series {
  font-size: 14px;
  color: #666;
}

.quick-attr-series b {
  margin-left: 4px;
  color: #333;
  font-weight: 600;
}

.quick-attr-actions a {
  margin-left: 14px;
  color: #57aca7;
  font-size: 13px;
}

.quick-attr-group + .quick-attr-group {
  margin-top: 10px;
}

.quick-attr-name {
  margin-bottom: 8px;
  color: #666;
  font-size: 13px;
}

.quick-attr-chips {
  display: flex;
  flex-wrap: wrap;
}

.quick-attr-chip {
  min-width: 44px;
  height: 28px;
  margin: 0 10px 10px 0;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  background: #fff;
  color: #555;
  font-size: 13px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
}

.quick-attr-chip:hover {
  border-color: #57aca7;
  color: #57aca7;
}

.quick-attr-chip.active {
  border-color: #57aca7;
  background: #57aca7;
  color: #fff;
}

.quick-attr-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.quick-attr-tip {
  color: #999;
  font-size: 12px;
}

.quick-attr-reset {
  color: #57aca7;
  font-size: 13px;
}
</style>
